import {
  TRIGGERED_EVENT_KEY,
  TRIGGER_ON_EVENT,
} from "@bloglovin/vue-component-library/animation";

// Pure, store-free helpers for authoring element trigger-events.

// Unique element-derived default name; strips the identifier's
// frame/multi-select syntax ("89:default.92:default" → "89").
export function generateUniqueEventName(existingEvents, elementIdentifier) {
  const existing = existingEvents ?? {};
  const firstIdentifier = String(elementIdentifier ?? "").split(".")[0];
  const bareElementId = firstIdentifier.split(":")[0] || "element";

  let name = `event-${bareElementId}`;
  let counter = 1;
  while (existing[name]) {
    counter += 1;
    name = `event-${bareElementId}-${counter}`;
  }
  return name;
}

// Copy of a raw animation-effects value with every listener/emitter
// reference renamed; null when nothing referenced the old name.
export function renameEventInAnimationEffects(rawValue, oldName, newName) {
  const valueIsUsable = rawValue && typeof rawValue === "object";
  if (!valueIsUsable) {
    return null;
  }

  let touched = false;
  const updated = {};
  Object.entries(rawValue).forEach(([trigger, effects]) => {
    if (!Array.isArray(effects)) {
      updated[trigger] = effects;
      return;
    }
    updated[trigger] = effects.map(effect => {
      const effectIsUsable = effect && typeof effect === "object";
      if (!effectIsUsable) {
        return effect;
      }

      const copy = { ...effect };
      const listensToOldName = trigger === TRIGGER_ON_EVENT && copy.event === oldName;
      if (listensToOldName) {
        copy.event = newName;
        touched = true;
      }

      const emitsOldName = copy[TRIGGERED_EVENT_KEY] === oldName;
      if (emitsOldName) {
        copy[TRIGGERED_EVENT_KEY] = newName;
        touched = true;
      }
      return copy;
    });
  });

  return touched ? updated : null;
}
